const comments = [
  {
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20warm%20lighting%2C%20simple%20clean%20background%2C%20soft%20natural%20makeup%2C%20friendly%20expression&width=100&height=100&seq=avatar-01&orientation=squarish',
    time: '2小时前',
    text: '在6080新视觉影视追完了《庆余年》第二季，画质真的太清晰了！而且完全免费不用注册，比那些要会员的网站良心太多了。更新速度也快，基本上电视台播出当天就能看到，强烈推荐！',
    drama: '《庆余年》第二季',
    stars: 5,
  },
  {
    name: '深夜刷剧人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20with%20warm%20lighting%2C%20casual%20style%2C%20simple%20clean%20background%2C%20friendly%20smile&width=100&height=100&seq=avatar-02&orientation=squarish',
    time: '6小时前',
    text: '每天都在这里追《长相思》，1080P看着太舒服了。页面也很干净，没有乱七八糟的弹窗广告，体验感非常好。剧集资源也很全，国产剧韩剧都有，收藏这个网站就够了。',
    drama: '《长相思》',
    stars: 5,
  },
  {
    name: '剧荒终结者',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20woman%20portrait%20with%20soft%20warm%20natural%20lighting%2C%20modern%20casual%20look%2C%20simple%20neutral%20background%2C%20pleasant%20expression&width=100&height=100&seq=avatar-03&orientation=squarish',
    time: '昨天',
    text: '之前总是找不到高清资源，自从发现了6080新视觉影视，彻底解决了我的剧荒问题。《与凤行》和《繁花》都是在这里看完的，播放流畅不卡顿，还能在手机上随时随地看，真心方便！',
    drama: '《与凤行》',
    stars: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-500/10 border border-secondary-500/20 mb-4">
            <i className="ri-chat-heart-line text-secondary-400 text-xs"></i>
            <span className="text-secondary-300 text-xs font-medium">追剧心声</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            剧迷们都在说
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            来自真实追剧用户的体验分享，好口碑看得见
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="relative p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
                <div className="flex items-center gap-0.5 shrink-0">
                  {Array.from({ length: comment.stars }).map((_, j) => (
                    <i key={j} className="ri-star-fill text-primary-400 text-xs"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
              <div className="mt-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-primary-50">
                <i className="ri-movie-2-line text-primary-400 text-xs"></i>
                <span className="text-xs text-primary-600 font-medium">{comment.drama}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}